/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Load_ErrorInputs */



/**
* | output |
* | --- |
* | "There was an issue loading share codes. Please close and reopen this window." |
*
* @param {Team_Share_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_load_error = /** @type {((inputs?: Team_Share_Load_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Load_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un problème est survenu lors du chargement des codes de partage. Veuillez fermer et rouvrir cette fenêtre.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Beim Laden der Freigabecodes ist ein Problem aufgetreten. Bitte schließen Sie dieses Fenster und öffnen Sie es erneut.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si è verificato un problema durante il caricamento dei codici di condivisione. Chiudi e riapri questa finestra.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Возникла проблема при загрузке кодов доступа. Пожалуйста, закройте и откройте это окно снова.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Hubo un problema al cargar los códigos para compartir. Cierre y vuelva a abrir esta ventana.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分享码加载失败。请关闭并重新打开此窗口。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("シェアコードの読み込み中に問題が発生しました。このウィンドウを閉じて再度開いてください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शेयर कोड लोड करने में समस्या आ रही है। कृपया इस विंडो को बंद करके दोबारा खोलें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ocorreu um problema ao carregar os códigos de compartilhamento. Feche e abra esta janela novamente.")
	return /** @type {LocalizedString} */ ("There was an issue loading share codes. Please close and reopen this window.")
});